import { render, staticRenderFns } from "./messageTable.vue?vue&type=template&id=52205de7"
import script from "./messageTable.vue?vue&type=script&lang=js"
export * from "./messageTable.vue?vue&type=script&lang=js"
import style0 from "./messageTable.vue?vue&type=style&index=0&id=52205de7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports